import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    gridContainer: { gap: 20 },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    actionUseAsShippingAddressButton: { 
        color: "primary", 
        css:css`
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
        `,
    },
    actionEditLink: {
        css: css`
            display: block;
            margin: 20px auto 0 auto;
            span {
                color: #006BC0 !important;
            }
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${getColor("common.border")};
            width: 100%;
        `,
    },
    overflowMenu: {
        cssOverrides: {
            menu: css`
                width: 210px;
            `,
            wrapper:css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF;
            }
            `,
        },
    },
}

currentShippingAddressStyles.useBillingAddress = {
    button: {
        mergeCss:true,
        color: "secondary",
        css: css`
            margin-top: 20px;
        `,
    },
}